import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getReproductionsPhyto.success: {
            return action.payload;
        }

        case constants.getReproductionsPhyto.error: {
            return initialState;
        }

        case constants.getReproductionsPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}